import ExchangeTaskEntry from './ExchangeTaskEntry';
import { ExchangeTaskGroup } from './ExchangeTask.shared';

interface AgentExchangeProps {
  campaignId: string;
  group: ExchangeTaskGroup;
}

const AgentExchange = ({ campaignId, group }: AgentExchangeProps) => (
  <ExchangeTaskEntry
    actionButtonId="completeAgentExchangeBtn"
    campaignId={campaignId}
    group={group}
    panelKey="AgentExchangePanel"
    title="Agent Exchange"
  />
);

export default AgentExchange;
